<template>
  <div class="home-page tripening">
    <div class="home-page-head">
      <div class="home-page-head--container">
        <h1 class="home-page-heading fw-bold" v-html="$siteConfig.tagline"></h1>
      </div>
      <div>
        <div class="search-tabs">
          <div class="search-tabs-container">
            <div class="search-tabs--list">
              <div
                  :class="['search-tabs--item', {active: searchTab === 'activities'}]"
                  @click="toggleSearchTab('activities')"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.25 7C12.25 4.10156 9.89844 1.75 7 1.75C4.10156 1.75 1.75 4.10156 1.75 7C1.75 9.89844 4.10156 12.25 7 12.25C9.89844 12.25 12.25 9.89844 12.25 7Z" stroke="#292929" stroke-width="1.5" stroke-miterlimit="10"/>
                  <path d="M9.58863 4.12699L6.38395 5.40887C6.16385 5.49689 5.96393 5.6287 5.79632 5.79632C5.6287 5.96393 5.49689 6.16385 5.40887 6.38395L4.12699 9.58863C4.11108 9.62839 4.10719 9.67194 4.11579 9.71388C4.12439 9.75583 4.14512 9.79433 4.1754 9.8246C4.20568 9.85488 4.24417 9.87561 4.28612 9.88421C4.32807 9.89282 4.37162 9.88892 4.41137 9.87301L7.61606 8.59113C7.83615 8.50312 8.03607 8.3713 8.20369 8.20369C8.3713 8.03607 8.50312 7.83615 8.59113 7.61606L9.87301 4.41137C9.88892 4.37162 9.89282 4.32807 9.88421 4.28612C9.87561 4.24417 9.85488 4.20568 9.8246 4.1754C9.79433 4.14512 9.75583 4.12439 9.71388 4.11579C9.67194 4.10719 9.62839 4.11108 9.58863 4.12699ZM7 7.65625C6.87021 7.65625 6.74333 7.61776 6.63541 7.54565C6.52749 7.47354 6.44338 7.37105 6.39371 7.25114C6.34404 7.13122 6.33104 6.99927 6.35636 6.87197C6.38168 6.74467 6.44418 6.62774 6.53596 6.53596C6.62774 6.44418 6.74467 6.38168 6.87197 6.35636C6.99927 6.33104 7.13122 6.34404 7.25114 6.39371C7.37105 6.44338 7.47354 6.52749 7.54565 6.63541C7.61776 6.74333 7.65625 6.87021 7.65625 7C7.65625 7.17405 7.58711 7.34097 7.46404 7.46404C7.34097 7.58711 7.17405 7.65625 7 7.65625Z" fill="#292929"/>
                </svg>

                {{t('Experiences')}}
              </div>
              <div
                  :class="['search-tabs--item', {active: searchTab === 'hotels'}]"
                  @click="toggleSearchTab('hotels')"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_323_7186)">
                    <path d="M0.583496 12.25H1.86683M1.86683 12.25H7.00016M1.86683 12.25V3.85C1.86683 3.115 1.86683 2.7475 2.00671 2.46663C2.12991 2.21922 2.32562 2.01906 2.56753 1.89306C2.84216 1.75 3.2015 1.75 3.92016 1.75H4.94683C5.6655 1.75 6.02483 1.75 6.29946 1.89306C6.54093 2.01889 6.73724 2.21967 6.86028 2.46663C7.00016 2.74684 7.00016 3.11434 7.00016 3.84803V5.84959M7.00016 12.25H12.1335M7.00016 12.25V5.84959M7.00016 5.84959L7.2318 5.63566C7.7169 5.19006 7.95946 4.96759 8.23409 4.88294C8.47555 4.80853 8.73311 4.80853 8.97457 4.88294C9.2492 4.96759 9.49176 5.19006 9.97686 5.63566L11.4527 6.99212C11.7036 7.22247 11.8287 7.33797 11.9185 7.47578C11.9982 7.59827 12.0572 7.73359 12.0931 7.87609C12.1335 8.03688 12.1335 8.20947 12.1335 8.554V12.25M12.1335 12.25H13.4168" stroke="#292929" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_323_7186">
                      <rect width="14" height="14" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                {{t('Hotels')}}
              </div>
            </div>
          </div>
        </div>
        <template v-if="searchTab === 'hotels'">
          <SearchPanel />
        </template>
        <template v-if="searchTab === 'activities'">
          <ActivitiesSearchPanel />
        </template>
      </div>
    </div>
    <PopularDestinations />
    <Moments />
    <TravelWithConfidence />
  </div>
</template>
<script setup lang="ts">
import TravelWithConfidence from "~/components/HomePage/TravelWithConfidence.vue";
import Moments from "~/components/HomePage/MakingEveryMomentCount.vue";
import PopularDestinations from "~/components/HomePage/PopularDestinations.vue";
const ActivitiesSearchPanel = defineAsyncComponent(() => import("~/components/SearchPanel/ActivitiesSearchPanel.vue"));
const { $siteConfig } = useNuxtApp()
const { t } = useI18n()

useHead({
  link: [
    { rel: 'preload', as: 'image', href: '/images/t-home-page.webp', fetchpriority: 'high' }
  ]
})

const searchTab = ref<String>('hotels')

const toggleSearchTab = (tab:string) => {
  searchTab.value = tab
  localStorage.setItem('searchTab', tab)
}

onMounted(() => {
  const tab = localStorage.getItem('searchTab')
  if (tab) {
    searchTab.value = tab
  }
})
</script>

<style lang="scss">
.home-page.tripening {
  width: 100%;
  padding: 0;

  min-height: 100vh;

  .home-page-head {
    background: url("/images/t-home-page.webp") center no-repeat;
    background-size: cover;

    &--container {
      max-width: 1120px;
      padding-top: 60px;
      margin: 0 auto;
      min-height: 246px;
      font-weight: 700;
      font-size: 44px;
      line-height: 56px;
      letter-spacing: 0;
      color: #fff;

      @media screen and (max-width: 1252px) {
        padding: 60px 16px 0 16px;
      }

      @media screen and (max-width: 768px) {
        font-size: 24px;
        line-height: 32px;
        padding: 30px 16px;
        min-height: 185px;
      }
    }

    .home-page-heading {
      margin: 0;
      font-weight: inherit;
      font-size: inherit;
      line-height: inherit;
    }

    @media screen and (max-width: 768px) {
      background: url("/images/t-home-page.webp") top center;
      background-size: 120%;
    }
  }
  &-logo {
    font-size: 64px;
    line-height: 78px;
    text-align: center;
    margin-bottom: 32px;
    padding: 0 15px;

    @media (max-width: 1024px) {
      font-size: 48px;
      line-height: 60px;
    }

    @media (max-width: 768px) {
      font-size: 32px;
      line-height: 42px;
      margin-bottom: 24px;
    }
  }

  .search-tabs {
    background: none;

    @media (max-width: 1152px) {
      padding: 0 16px;
    }

    &-container {
      width: 100%;
      max-width: var(--content-max-width);
      margin: 0 auto;
      padding-top: 28px;
    }

    &--list {
      display: flex;
      border-bottom: 2px solid var(--grey-border);
      margin-bottom: -2px;
    }

    &--item {
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
      color: #292929;
      position: relative;
      padding: 6px 16px;
      cursor: pointer;
      background: #E3EFEF;
      display: flex;
      align-items: center;
      gap: 8px;
      &.active {
        color: #0B5351;

        &::after {
          content: "";
          display: block;
          position: absolute;
          bottom: 0px;
          left: 0;
          right: 0;
          height: 2px;
          background-color: #0B5351;
        }

        svg {
          path {
            stroke: #0B5351;
          }
        }
      }

      &:first-child {
        border-top-left-radius: 8px;
      }
      &:last-child {
        border-top-right-radius: 8px;
      }
    }
  }

  .search-panel-container {
    background: #E3EFEF;


    .search-panel {
      border-radius: 6px;
    }
    @media (max-width: 1152px) {
      padding: 16px;
    }
  }

  .attractions-container {
    max-width: var(--content-max-width);
    margin: 0 auto;
    padding: 40px 0;
  }
}
</style>
